import React from 'react';
import * as Scrivito from 'scrivito';

Scrivito.provideWidgetClass('HeadlineWidget', {
  attributes: {
    headline: 'string',
  },
});

const HeadlineWidget = Scrivito.connect(({ widget }) => (
  <div className="center-heading">
    <Scrivito.ContentTag tag="h2" attribute="headline" content={widget} />
    <div className="center-line" />
  </div>
));

Scrivito.provideComponent('HeadlineWidget', HeadlineWidget);

Scrivito.provideEditingConfig('HeadlineWidget', {
  title: 'Headline',
  properties: ['headline'],
  attributes: {
    headline: { title: 'Headline' },
  },
});

export default HeadlineWidget;
